import { FC, SetStateAction, useEffect, useState } from 'react';

import {
  DownOutlined,
} from '@ant-design/icons';
import {
  Button,
  Dropdown,
  Form,
  Input,
  MenuProps,
  Modal,
} from 'antd';
import axios from 'axios';
import moment from 'moment/moment';
import { useLocation, useNavigate } from 'react-router-dom';

import {
  formatPeriod,
  getFiltersWithoutSegment,
} from '../../../../../../helpers/utils/functions';
import {
  showErrorMessage,
  showSuccessMessage,
} from '../../../../../../helpers/utils/ui';
import { BlockVisible } from '../../../../../../pages/dashboards/types';
import { axiosConfigAuth } from '../../../../api/middleware';
import { API_UN_REPORT_EXEL } from '../../../../api/urls';
import { Roles } from '../../../../constants/user';
import { useActions } from '../../../../hooks/useActions';
import { useTypedSelector } from '../../../../hooks/useTypedSelector';

type Props = {
  setAddBlockVisible: React.Dispatch<
    SetStateAction<BlockVisible>
  >;
};
const UniversalReportTitle: FC<Props> = ({ setAddBlockVisible }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const { role } = useTypedSelector((state) => state.currentUser);
  const { selectedSchool } = useTypedSelector((state) => state.currentSchool);
  const { savedDashboards, currentDashboard, isLoadingReports } = useTypedSelector(
    (state) => state.reports
  );
  const period = useTypedSelector((state) => state.period);
  const { dashboards } = useTypedSelector((state) => state.dashboard);
  const detailsDashboard = useTypedSelector(
    (state) => state.details.detailsDashboard
  );
  const { filters, currentSegment } = useTypedSelector((state) => state.filter);
  const { attributes, attributesDashboard } = useTypedSelector(
    (state) => state.attributes
  );
  const {
    metrics,
    groupings,
  } = useTypedSelector((state) => state.table);
  const { isCompare } = useTypedSelector((state) => state.meta);

  const {
    postReport,
    putReport,
  } = useActions();
  const [ isModalVisible, setIsModalVisible ] = useState(false);
  const [ isModalCreateVisible, setIsModalCreateVisible ] = useState(false);
  const [ isModalXLSXVisible, setIsModalXLSXVisible ] = useState(false);
  const [ reportName, setReportName ] = useState('');
  const [ excelName, setExcelName ] = useState('');
  const [ isDisableSave, setIsDisableSave ] = useState(false);

  const reportParam = new URLSearchParams(location.search).get('report_id');

  useEffect(() => {
    if (savedDashboards.find((dashboard) => dashboard?.hash === reportParam)?.access_id <= Roles[role]) {
      setIsDisableSave(false);
    } else {
      setIsDisableSave(true);
    }
  }, [ location, savedDashboards ]);

  const save = () => {
    let values: any = {
      ...currentDashboard.values,
      period: {
        start: moment(period.start).format('YYYY-MM-DD'),
        end: moment(period.end).format('YYYY-MM-DD'),
        interval: period.interval || period.select,
        select: period.select || period.interval,
        days: null,
      },
      attributesDashboard,
      detailsDashboard,
      filters,
      segment: null,
      blocks: dashboards,
    };

    if (Object.keys(currentSegment || {}).length > 0) {
      values.segment = currentSegment;
      values.filters = getFiltersWithoutSegment(
        filters,
        currentSegment?.values?.filters
      );
    } else {
      values.segment = {};
      values.filters = filters;
    }

    if (selectedSchool?.id) {
      if (period.interval === 'ndaysago' || period.select === 'ndaysago') {
        values.period.days = period.days;
      }
      putReport(selectedSchool.id, { id: currentDashboard.id, values });
    }
  };

  const saveAs = () => {
    if (selectedSchool?.id) {
      let values: any = {
        name: reportName,
        period: {
          start: moment(period.start).format('YYYY-MM-DD'),
          end: moment(period.end).format('YYYY-MM-DD'),
          interval: period.interval || period.select,
          select: period.select || period.interval,
        },
        attributesDashboard,
        detailsDashboard,
        filters,
        segment: null,
        blocks: dashboards,
      };

      if (Object.keys(currentSegment || {}).length > 0) {
        values.segment = currentSegment;
        values.filters = getFiltersWithoutSegment(
          filters,
          currentSegment?.values?.filters
        );
      } else {
        let _filters = filters;
        if (!Array.isArray(filters)) {
          _filters = [];
        }
        values.filters = _filters;
      }
      if (period.interval === 'ndaysago' || period.select === 'ndaysago') {
        values.period.days = period.days;
      }
      const onSuccess = (report_id: string) => navigate(window.location.pathname + '?report_id=' + report_id);
      postReport(selectedSchool.id, { values, onSuccess });
      setIsModalVisible(false);
      setReportName('');
    }
  };

  const create = () => {
    if (selectedSchool?.id) {
      let values: any = {
        name: reportName,
        period: {
          start: moment(period.start).format('YYYY-MM-DD'),
          end: moment(period.end).format('YYYY-MM-DD'),
          interval: period.interval || period.select,
          select: period.select || period.interval,
        },
        attributesDashboard,
        detailsDashboard,
        filters,
        segment: null,
        blocks: dashboards,
      };
      if (Object.keys(currentSegment || {}).length > 0) {
        values.segment = currentSegment;
        values.filters = getFiltersWithoutSegment(
          filters,
          currentSegment?.values?.filters
        );
      } else {
        let _filters = filters;
        if (!Array.isArray(filters)) {
          _filters = [];
        }
        values.filters = _filters;
      }
      if (period.interval === 'ndaysago' || period.select === 'ndaysago') {
        values.period.days = period.days;
      }
      const onSuccess = (report_id: string) => navigate(window.location.pathname + '?report_id=' + report_id);
      postReport(selectedSchool.id, { values, onSuccess });
      setIsModalCreateVisible(false);
      setReportName('');
    }
  };

  const saveXSLX = () => {
    const format = 'YYYY-MM-DD';
    const _period = {
      ...formatPeriod({ start: period.start, end: period.end }, format),
    };
    const data = {
      name: excelName,
      period: _period,
      filters: attributes,
      groupings,
      metrics,
    };

    axios
      .post(API_UN_REPORT_EXEL, data, axiosConfigAuth())
      .then(() => {
        showSuccessMessage('Сохранено');
      })
      .catch(() => {
        showErrorMessage('Ошибка при сохранении');
      });

    setIsModalXLSXVisible(false);
    setExcelName('');
  };


  const savingItemsDropDown: MenuProps['items'] = [
    {
      key: '1',
      label: Object.keys(currentDashboard).length > 0 && !isDisableSave && (
        <span onClick={save}>Сохранить изменения</span>
      ),
    },
    {
      key: '2',
      label: <span onClick={() => setIsModalVisible(true)}>Сохранить как новый дашборд</span>,
    },
  ];

  const menuItems = [
        {
          key: '1',
          label: 'Блок',
          onClick: () => setAddBlockVisible({ visible: true, blockType: '' }),
        },
        {
          key: '2',
          label: 'Заголовок',
          onClick: () =>
            setAddBlockVisible({ visible: true, blockType: 'heading' }),
      },
  ];

  return (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '95%',
              marginTop: '10px',
              marginLeft: '100px',
              zIndex: 2
            }}
          >

         
            {!isCompare && dashboards?.length > 0 && (
              <div style={{ marginLeft: 'auto' }}>
                <Dropdown
                  overlayStyle={{ left: '1490px' }}
                  disabled={isCompare}
                  menu={{ items: savingItemsDropDown }}
                  trigger={[ 'click' ]}
                >
                  <Button  disabled={isCompare}
                  style={{
                    height: '45px',
                    marginRight: '10px',
                    borderRadius: '5px',
                  }} >
                    Сохранить
                  </Button>
                </Dropdown>
              </div>
            )}
            <Dropdown trigger={[ 'click' ]} menu={{ items: menuItems }}>
              <Button
                type="primary"
                style={{
                  backgroundColor: '#fe3f30',
                  color: 'white',
                  width: '170px',
                  height: '45px',
                  borderRadius: '5px',
                  border: 'none',
                  cursor: 'pointer',
                }}
              >
                Добавить блок <DownOutlined />
              </Button>
            </Dropdown>
          </div>
          <Modal
            title="Сохранить дашборд как"
            open={isModalVisible}
            onOk={() =>
              reportName
                ? saveAs()
                : showErrorMessage('Введите название дашборда')
            }
            onCancel={() => setIsModalVisible(false)}
            okText="Сохранить"
          >
            <Form>
              <Form.Item
                name="reportName"
                label="Название дашборда"
                rules={[
                  { required: true, message: 'Введите название дашборда' },
                  { min: 1, message: 'Введите название дашборда' },
                ]}
              >
                <Input
                  value={reportName}
                  onChange={(e) => setReportName(e.target.value)}
                  size="large"
                  placeholder="Введите название дашборда"
                  allowClear
                />
              </Form.Item>
            </Form>
          </Modal>
          <Modal
            title="Создать дашборд"
            open={isModalCreateVisible}
            onOk={create}
            onCancel={() => setIsModalCreateVisible(false)}
            okText="Сохранить"
          >
            <Input
              value={reportName}
              onChange={(e) => setReportName(e.target.value)}
              size="large"
              placeholder="Введите название дашборда"
              allowClear
            />
          </Modal>
          <Modal
            title="Скачать XLSX таблицы"
            open={isModalXLSXVisible}
            onOk={saveXSLX}
            onCancel={() => setIsModalXLSXVisible(false)}
            okText="Сохранить"
          >
            <Input
              value={excelName}
              onChange={(e) => setExcelName(e.target.value)}
              size="large"
              placeholder="Введите название файла"
              allowClear
            />
          </Modal>
        </div>
  );
};

export default UniversalReportTitle;
